import styled, { css } from 'styled-components'

export const Subtitle = styled.div<{ $required?: boolean }>`
  color: #757575;
  font-size: 14px;
  font-weight: 700;
  padding: 16px 0 4px;
  svg {
    margin-left: 6px;
  }
  ${(props) =>
    props.$required &&
    css`
      &::after {
        content: ' *';
        color: #f5222d;
      }
      svg {
        position: absolute;
        margin-left: 16px;
        margin-top: 3px;
      }
    `}
`

export const CharacterCounter = styled.div`
  margin-top: 4px;
  font-size: 12px;
`

export const FieldError = styled.div`
  margin-top: 4px;
  color: #f5222d;
  font-size: 12px;
  line-height: 1.4;
`
